export default "__VITE_ASSET__BI6X8Tlu__"